// extracted by mini-css-extract-plugin
export default {"icon":"mAZF70It--Icon_icon__w6Pjo","icon__svg":"mAZF70It--Icon_icon__svg__O9OPL","iconSvg":"mAZF70It--Icon_icon__svg__O9OPL"};